<template>
  <div>
    <div v-if="loading" class="mt-5 mb-5">
      <spinner position="center"></spinner>
    </div>
    <form
      v-if="client"
      v-show="!loading"
      id="personalDataForm"
      ref="personalDataForm"
      method="POST"
      class="ang-card-body"
      :action="action"
    >
      <input type="hidden" name="data[step_1]" value="1" />
      <input type="hidden" name="code" :value="code" />
      <div>
        <div class="row">
          <div class="col-12 col-md-6">
            <p class="ang-card-title mt-3">Dane osobowe</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label" for="first_name">Imię</label>
              <input
                type="text"
                class="ang-form-control"
                id="first_name"
                name="first_name"
                :required="!is_expert"
                v-model="client.first_name"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label" for="first_name">Drugie imię</label>
              <input
                type="text"
                class="ang-form-control"
                id="second_name"
                name="data[details][second_name]"
                v-model="client.data.details.second_name"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label" for="last_name">Nazwisko</label>
              <input
                type="text"
                class="ang-form-control"
                id="last_name"
                name="last_name"
                :required="!is_expert"
                v-model="client.last_name"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Adres e-mail</label>
              <input
                type="email"
                class="ang-form-control email"
                id="email"
                name="email"
                :required="!is_expert"
                v-model="client.email"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Nr telefonu</label>
              <input
                type="text"
                class="ang-form-control dig phone"
                id="phone1"
                name="phone"
                :required="!is_expert"
                v-model="client.phone"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Drugi numer telefonu</label>
              <input
                type="text"
                class="ang-form-control dig phone"
                id="phone2"
                name="data[details][secondary_phone]"
                v-model="client.data.details.secondary_phone"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Obywatelstwo</label>
              <select-field
                name="data[details][citizenship]"
                css="width: 100%"
                :required="!is_expert"
                :options="dictionary.taxCountry"
                @changed="refreshForm"
                v-model="client.data.details.citizenship"
                :search="true"
                :selected="client.data.details.citizenship"
              ></select-field>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Kraj zamieszkania</label>
              <select-field
                name="data[details][home_country]"
                css="width: 100%"
                placeholder="Wybierz"
                :required="!is_expert"
                :options="dictionary.taxCountry"
                @changed="refreshForm"
                v-model="client.data.details.home_country"
                :search="true"
                :selected="client.data.details.home_country"
              ></select-field>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Kraj urodzenia</label>
              <select-field
                name="data[details][birth_country]"
                css="width: 100%"
                placeholder="Wybierz"
                :required="!is_expert"
                :options="dictionary.taxCountry"
                @changed="refreshForm"
                v-model="client.data.details.birth_country"
                :search="true"
                :selected="client.data.details.birth_country"
              ></select-field>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Miejscowość urodzenia</label>
              <input
                type="text"
                class="ang-form-control"
                id="birth_city"
                name="data[details][birth_city]"
                :required="!is_expert"
                v-model="client.data.details.birth_city"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label" for="pesel">PESEL</label>
              <input
                type="text"
                class="ang-form-control dig pesel"
                id="pesel"
                name="pesel"
                :required="
                  !is_expert &&
                  (!client.data.details.citizenship ||
                  client.data.details.citizenship.length === 0 ||
                  client.data.details.citizenship === 'Polska')
                "
                v-model="client.pesel"
              />
            </div>
          </div>
          <div
            class="col-12 col-md-4"
            v-show="
              client.data.details.citizenship &&
              client.data.details.citizenship.length > 0 &&
              client.data.details.citizenship !== 'Polska'
            "
          >
            <div class="form-group">
              <label class="ang-form-label" for="pesel">Data urodzenia</label>
              <input
                type="text"
                class="ang-form-control datepicker"
                name="data[details][birth_date]"
                :required="
                  !is_expert &&
                  client.data.details.citizenship &&
                  client.data.details.citizenship.length > 0 &&
                  client.data.details.citizenship !== 'Polska'
                "
                v-model="client.data.details.birth_date"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Imię ojca</label>
              <input
                type="text"
                class="ang-form-control"
                id="father_name"
                name="data[details][father_name]"
                v-model="client.data.details.father_name"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Imię matki</label>
              <input
                type="text"
                class="ang-form-control"
                id="mother_name"
                name="data[details][mother_name]"
                v-model="client.data.details.mother_name"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Nazwisko rodowe matki</label>
              <input
                type="text"
                class="ang-form-control"
                id="mother_lastname"
                name="data[details][mother_lastname]"
                v-model="client.data.details.mother_lastname"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Nazwisko rodowe</label>
              <input
                type="text"
                class="ang-form-control"
                id="family_name"
                name="data[details][family_name]"
                v-model="client.data.details.family_name"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-12 col-md-6">
            <p class="ang-card-title mt-3">Dokument tożsamości</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Typ dokumentu tożsamości</label>
              <select-field
                name="data[details][id_type]"
                css="width: 100%"
                :required="!is_expert"
                @changed="onDocumentTypeChanged"
                :options="{
                  values: [
                    { val: 'Dowód osobisty', text: 'Dowód osobisty' },
                    {
                      val: 'Dokument mObywatel - mDowód',
                      text: 'Dokument mObywatel - mDowód',
                    },
                    { val: 'Paszport', text: 'Paszport' },
                    { val: 'Karta pobytu', text: 'Karta pobytu' },
                  ],
                }"
                v-model="client.data.details.id_type"
                :selected="client.data.details.id_type"
              ></select-field>
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="form-group">
              <label class="ang-form-label">Data wydania</label>
              <input
                type="text"
                class="ang-form-control datepicker dateBeforeNow dateCorrect"
                id="issue_date"
                :data-primary="true"
                name="data[details][issue_date]"
                autocomplete="off"
                v-model="client.data.details.issue_date"
              />
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="form-group">
              <label class="ang-form-label">Data ważności</label>
              <input
                type="text"
                class="ang-form-control datepicker dateAfterNow dateCorrect"
                id="validity_date"
                name="data[details][validity_date]"
                autocomplete="off"
                :disabled="client.data.details.validity_date_indefinite"
                v-model="client.data.details.validity_date"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group pt-4">
              <label class="ang-form-label"></label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :value="1"
                  :disabled="
                    client.data.details.id_type ===
                    'Dokument mObywatel - mDowód'
                  "
                  id="validity_date_indefinite"
                  name="data[details][validity_date_indefinite]"
                  @change="refreshForm"
                  v-model="client.data.details.validity_date_indefinite"
                  :checked="
                    client.data.details.validity_date_indefinite &&
                    client.data.details.validity_date_indefinite === true
                  "
                />
                <label
                  class="form-check-label"
                  for="validity_date_indefinite"
                  style="margin-top: 3px"
                >
                  Bezterminowy
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Seria i numer dokumentu</label>
              <input
                v-if="
                  client.data.details.id_type === 'Dowód osobisty' ||
                  client.data.details.id_type === 'Dokument mObywatel - mDowód'
                "
                type="text"
                class="ang-form-control idNumber"
                id="id_number_validation"
                name="data[details][id_number]"
                :required="!is_expert"
                v-model="client.data.details.id_number"
                @focusout="
                  client.data.details.id_number =
                    $event.target.value.toUpperCase()
                "
              />
              <input
                v-else
                type="text"
                class="ang-form-control"
                id="id_number"
                name="data[details][id_number]"
                :required="!is_expert"
                v-model="client.data.details.id_number"
                @focusout="
                  client.data.details.id_number =
                    $event.target.value.toUpperCase()
                "
              />
            </div>
          </div>
          <div class="col-12 col-md-8">
            <div class="form-group">
              <label class="ang-form-label"
                >Organ wydający dokument tożsamości</label
              >
              <input
                type="text"
                class="ang-form-control"
                id="issuer"
                :disabled="
                  client.data.details.id_type === 'Dokument mObywatel - mDowód'
                "
                name="data[details][id_issuer]"
                v-model="client.data.details.id_issuer"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-show="showSecondID">
        <div class="row">
          <div class="col-12 col-md-6">
            <p class="ang-card-title mt-3">Drugi dokument tożsamości</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Typ dokumentu tożsamości</label>
              <select-field
                name="data[details][id_type_alt]"
                css="width: 100%"
                @changed="refreshForm"
                :options="{
                  values: [
                    { val: 'Paszport', text: 'Paszport' },
                    { val: 'Karta pobytu', text: 'Karta pobytu' },
                  ].filter(function (obj) {
                    return obj.val !== client.data.details.id_type;
                  }),
                }"
                v-model="client.data.details.id_type_alt"
              />
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="form-group">
              <label class="ang-form-label">Data wydania</label>
              <input
                type="text"
                class="ang-form-control datepicker"
                :data-alt="true"
                :class="{
                  dateBeforeNow: showSecondID,
                  dateCorrect: showSecondID,
                }"
                id="issue_date_alt"
                name="data[details][issue_date_alt]"
                autocomplete="off"
                v-model="client.data.details.issue_date_alt"
              />
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="form-group">
              <label class="ang-form-label">Data ważności</label>
              <input
                type="text"
                class="ang-form-control datepicker"
                :class="{
                  dateAfterNow: showSecondID,
                  dateCorrect: showSecondID,
                }"
                id="validity_date_alt"
                name="data[details][validity_date_alt]"
                autocomplete="off"
                :disabled="client.data.details.validity_date_indefinite_alt"
                v-model="client.data.details.validity_date_alt"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group pt-4">
              <label class="ang-form-label"></label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :value="1"
                  id="validity_date_indefinite_alt"
                  name="data[details][validity_date_indefinite_alt]"
                  @change="refreshForm"
                  v-model="client.data.details.validity_date_indefinite_alt"
                  :checked="
                    client.data.details.validity_date_indefinite_alt &&
                    client.data.details.validity_date_indefinite_alt === true
                  "
                />
                <label
                  class="form-check-label"
                  for="validity_date_indefinite_alt"
                  style="margin-top: 3px"
                >
                  Bezterminowy
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Seria i numer dokumentu</label>
              <input
                type="text"
                v-if="client.data.details.id_type_alt === 'Dowód osobisty'"
                class="ang-form-control idNumber"
                id="id_number_alt_valid"
                name="data[details][id_number_alt]"
                v-model="client.data.details.id_number_alt"
                @focusout="
                  client.data.details.id_number_alt =
                    $event.target.value.toUpperCase()
                "
              />
              <input
                v-else
                type="text"
                class="ang-form-control"
                id="id_number_alt"
                name="data[details][id_number_alt]"
                v-model="client.data.details.id_number_alt"
                @focusout="
                  client.data.details.id_number_alt =
                    $event.target.value.toUpperCase()
                "
              />
            </div>
          </div>
          <div class="col-12 col-md-8">
            <div class="form-group">
              <label class="ang-form-label"
                >Organ wydający dokument tożsamości</label
              >
              <input
                type="text"
                class="ang-form-control"
                id="issuer_alt"
                name="data[details][id_issuer_alt]"
                v-model="client.data.details.id_issuer_alt"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-12 col-md-6">
            <p class="ang-card-title mt-3">Informacje osobiste</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Status mieszkaniowy</label>
              <select-field
                name="data[details][housing_status]"
                css="width: 100%"
                placeholder="Wybierz"
                :required="!is_expert"
                :options="dictionary.housingOptions"
                @changed="refreshForm"
                v-model="client.data.details.housing_status"
                :selected="client.data.details.housing_status"
              ></select-field>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Wykształcenie</label>
              <select-field
                name="data[details][education_status]"
                css="width: 100%"
                placeholder="Wybierz"
                :required="!is_expert"
                @changed="refreshForm"
                :options="dictionary.educationOptions"
                v-model="client.data.details.education_status"
                :selected="client.data.details.education_status"
              ></select-field>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Stan cywilny</label>
              <select-field
                name="data[details][martial_status]"
                css="width: 100%"
                placeholder="Wybierz"
                :required="!is_expert"
                :options="dictionary.martialOptions"
                @changed="refreshForm"
                v-model="client.data.details.martial_status"
                :selected="client.data.details.martial_status"
              ></select-field>
            </div>
          </div>
          <div
            class="col-12 col-md-4"
            v-show="client.data.details.housing_status === 'Inne'"
          >
            <div class="form-group">
              <label class="ang-form-label">Status mieszkaniowy</label>
              <input
                type="text"
                class="ang-form-control"
                name="data[details][housing_status_description]"
                :required="!is_expert && client.data.details.housing_status === 'Inne'"
                v-model="client.data.details.housing_status_description"
              />
            </div>
          </div>
          <div
            class="col-12 col-md-4"
            v-show="client.data.details.education_status === 'inne'"
          >
            <div class="form-group">
              <label class="ang-form-label">Wykształcenie</label>
              <input
                type="text"
                class="ang-form-control"
                name="data[details][education_status_description]"
                :required="!is_expert && client.data.details.education_status === 'inne'"
                v-model="client.data.details.education_status_description"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <!--                    <div class="col-12 col-md-4">-->
          <!--                        <div class="form-group">-->
          <!--                            <label class="ang-form-label">Związek ze Współwnioskodawcą</label>-->
          <!--                            <select-field name="data[details][house_hold_type]" css="width: 100%" placeholder="Wybierz"-->
          <!--                                          required :options="dictionary.typeHousehold" v-model="client.data.details.house_hold_type" :selected="client.data.details.house_hold_type"></select-field>-->
          <!--                        </div>-->
          <!--                    </div>-->
          <div
            class="col-12 col-md-4"
            v-if="client.data.details.martial_status === 'Mężatka/Żonaty'"
          >
            <div class="form-group">
              <label class="ang-form-label">Rozdzielność majątkowa</label>
              <select-field
                name="data[details][martial_separation]"
                css="width: 100%"
                placeholder="Wybierz"
                :required="!is_expert"
                @changed="refreshForm"
                :options="{
                  values: [
                    { val: 'Tak', text: 'Tak' },
                    { val: 'Nie', text: 'Nie' },
                  ],
                }"
                v-model="client.data.details.martial_separation"
                :selected="client.data.details.martial_separation"
              ></select-field>
            </div>
          </div>
          <div
            class="col-12 col-md-4"
            v-if="client.data.details.martial_status === 'Mężatka/Żonaty'"
          >
            <div class="form-group">
              <label class="ang-form-label">Wspólne rozliczanie PIT</label>
              <select-field
                name="data[details][mutual_accounting]"
                css="width: 100%"
                placeholder="Wybierz"
                :required="!is_expert"
                @changed="refreshForm"
                :options="{
                  values: [
                    { val: 'Tak', text: 'Tak' },
                    { val: 'Nie', text: 'Nie' },
                  ],
                }"
                v-model="client.data.details.mutual_accounting"
                :selected="client.data.details.mutual_accounting"
              ></select-field>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-12 col-md-6">
            <p class="ang-card-title mt-3">Gospodarstwo domowe</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Liczba dorosłych bez dochodu</label>
              <select-field
                name="data[details][noIncomePeople]"
                css="width: 100%"
                placeholder="Wybierz"
                :required="!is_expert"
                :options="dictionary.childernOptions"
                @changed="refreshForm"
                v-model="client.data.details.noIncomePeople"
                :selected="client.data.details.noIncomePeople"
              ></select-field>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Liczba dzieci na utrzymaniu</label>
              <select-field
                name="data[details][childrenPeople]"
                css="width: 100%"
                placeholder="Wybierz"
                :required="!is_expert"
                :options="dictionary.childernOptions"
                @changed="refreshForm"
                v-model="client.data.details.childrenPeople"
                :selected="client.data.details.childrenPeople"
              ></select-field>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">W sumie osób w gospodarstwie</label>
              <select-field
                name="data[details][homePeople]"
                css="width: 100%"
                placeholder="Wybierz"
                lessThanField="#peopleSum"
                :required="!is_expert"
                :options="dictionary.peopleOptions"
                @changed="refreshForm"
                v-model="client.data.details.homePeople"
                :selected="client.data.details.homePeople"
              ></select-field>
            </div>
          </div>
          <input
            id="peopleSum"
            type="hidden"
            :value="
              parseInt(client.data.details.childrenPeople) +
              parseInt(client.data.details.noIncomePeople)
            "
          />
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-12 col-md-6">
            <p class="ang-card-title mt-3">Adres zameldowania</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label" for="privatePostal"
                >Kod pocztowy</label
              >
              <input
                type="text"
                class="postal ang-form-control"
                id="privatePostal"
                name="address[private][postal]"
                :required="!is_expert"
                v-model="client.address.private.postal"
                @keyup="getAddress($event.target.value, 'private')"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label" for="privateStreet">Ulica</label>
              <input
                type="text"
                class="ang-form-control"
                id="privateStreet"
                name="address[private][street]"
                :required="!is_expert"
                v-model="client.address.private.street"
              />
            </div>
          </div>
          <div class="col-6 col-md-2">
            <div class="form-group">
              <label class="ang-form-label" for="privateNumber"
                >Nr budynku</label
              >
              <input
                type="text"
                class="ang-form-control"
                id="privateNumber"
                name="address[private][number]"
                :required="!is_expert"
                v-model="client.address.private.number"
              />
            </div>
          </div>
          <div class="col-6 col-md-2">
            <div class="form-group">
              <label class="ang-form-label" for="privateFlat">Nr lokalu</label>
              <input
                type="text"
                class="ang-form-control"
                id="privateFlat"
                name="address[private][flat]"
                v-model="client.address.private.flat"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label" for="privateCountry">Kraj</label>
              <input
                type="text"
                class="ang-form-control"
                id="privateCountry"
                name="address[private][country]"
                :required="!is_expert"
                v-model="client.address.private.country"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label" for="privateCity">Miasto</label>
              <input
                type="text"
                class="ang-form-control"
                id="privateCity"
                name="address[private][city]"
                :required="!is_expert"
                v-model="client.address.private.city"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label" for="privatePostOffice"
                >Poczta</label
              >
              <input
                type="text"
                class="ang-form-control"
                id="privatePostOffice"
                name="address[private][post_office]"
                :required="!is_expert"
                v-model="client.address.private.post_office"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label" for="privateCommune">Gmina</label>
              <input
                type="text"
                class="ang-form-control"
                id="privateCommune"
                name="address[private][commune]"
                :required="!is_expert"
                v-model="client.address.private.commune"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label" for="privateCounty">Powiat</label>
              <input
                type="text"
                class="ang-form-control"
                id="privateCounty"
                name="address[private][county]"
                :required="!is_expert"
                v-model="client.address.private.county"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label">Województwo</label>
              <select-field
                name="address[private][province]"
                css="width: 100%"
                :required="!is_expert"
                :options="dictionary.provinces"
                @changed="refreshForm"
                v-model="client.address.private.province"
                :selected="client.address.private.province"
              ></select-field>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="">
          <p class="ang-card-title mt-3 mr-2">Adres zamieszkania</p>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label"
                >Taki sam jak adres zameldowania?</label
              >
              <select-field
                name="data[details][address1]"
                css="width: 100%"
                :required="!is_expert"
                @changed="fillAddress($event, 'private', 'home')"
                placeholder="Wybierz"
                :options="{
                  values: [
                    { val: 'Tak', text: 'Tak' },
                    { val: 'Nie', text: 'Nie' },
                  ],
                }"
                v-model="client.data.details.address1"
                :selected="client.data.details.address1"
              ></select-field>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label"
                >Data zamieszkania w gospodarstwie (od)</label
              >
              <input
                type="text"
                class="ang-form-control datepicker"
                name="data[details][date_from]"
                :required="!is_expert"
                v-model="client.data.details.date_from"
              />
            </div>
          </div>
        </div>

        <div v-if="client.data.details.address1 === 'Tak'">
          <input
            type="hidden"
            name="address[home][postal]"
            v-model="client.address.private.postal"
          />
          <input
            type="hidden"
            name="address[home][street]"
            v-model="client.address.private.street"
          />
          <input
            type="hidden"
            name="address[home][number]"
            v-model="client.address.private.number"
          />
          <input
            type="hidden"
            name="address[home][flat]"
            v-model="client.address.private.flat"
          />
          <input
            type="hidden"
            name="address[home][country]"
            v-model="client.address.private.country"
          />
          <input
            type="hidden"
            name="address[home][city]"
            v-model="client.address.private.city"
          />
          <input
            type="hidden"
            name="address[home][post_office]"
            v-model="client.address.private.post_office"
          />
          <input
            type="hidden"
            name="address[home][county]"
            v-model="client.address.private.county"
          />
          <input
            type="hidden"
            name="address[home][province]"
            v-model="client.address.private.province"
          />
        </div>
        <div v-else>
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="homePostal"
                  >Kod pocztowy</label
                >
                <input
                  type="text"
                  class="postal ang-form-control"
                  id="homePostal"
                  name="address[home][postal]"
                  :required="!is_expert && client.data.details.address1 === 'Nie'"
                  v-model="client.address.home.postal"
                  @keyup="getAddress($event.target.value, 'home')"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="homeStreet">Ulica</label>
                <input
                  type="text"
                  class="ang-form-control"
                  id="homeStreet"
                  name="address[home][street]"
                  :required="!is_expert && client.data.details.address1 === 'Nie'"
                  v-model="client.address.home.street"
                />
              </div>
            </div>
            <div class="col-6 col-md-2">
              <div class="form-group">
                <label class="ang-form-label" for="homeNumber"
                  >Nr budynku</label
                >
                <input
                  type="text"
                  class="ang-form-control"
                  id="homeNumber"
                  name="address[home][number]"
                  :required="!is_expert && client.data.details.address1 === 'Nie'"
                  v-model="client.address.home.number"
                />
              </div>
            </div>
            <div class="col-6 col-md-2">
              <div class="form-group">
                <label class="ang-form-label" for="homeFlat">Nr lokalu</label>
                <input
                  type="text"
                  class="ang-form-control"
                  id="homeFlat"
                  name="address[home][flat]"
                  v-model="client.address.home.flat"
                />
              </div>
            </div>

            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="homeCountry">Kraj</label>
                <input
                  type="text"
                  class="ang-form-control"
                  id="homeCountry"
                  name="address[home][country]"
                  :required="!is_expert"
                  v-model="client.address.home.country"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="homeCity">Miasto</label>
                <input
                  type="text"
                  class="ang-form-control"
                  id="homeCity"
                  name="address[home][city]"
                  :required="!is_expert && client.data.details.address1 === 'Nie'"
                  v-model="client.address.home.city"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="homePostOffice"
                  >Poczta</label
                >
                <input
                  type="text"
                  class="ang-form-control"
                  id="homePostOffice"
                  name="address[home][post_office]"
                  :required="!is_expert && client.data.details.address1 === 'Nie'"
                  v-model="client.address.home.post_office"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="homeCommune">Gmina</label>
                <input
                  type="text"
                  class="ang-form-control"
                  id="homeCommune"
                  name="address[home][commune]"
                  :required="!is_expert && client.data.details.address1 === 'Nie'"
                  v-model="client.address.home.commune"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="homeCounty">Powiat</label>
                <input
                  type="text"
                  class="ang-form-control"
                  id="homeCounty"
                  name="address[home][county]"
                  :required="!is_expert && client.data.details.address1 === 'Nie'"
                  v-model="client.address.home.county"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label">Województwo</label>
                <select-field
                  name="address[home][province]"
                  css="width: 100%"
                  :required="!is_expert && client.data.details.address1 === 'Nie'"
                  :options="dictionary.provinces"
                  @changed="refreshForm"
                  v-model="client.address.home.province"
                  :selected="client.address.home.province"
                ></select-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <p class="ang-card-title mt-3">Adres korespondencyjny</p>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="ang-form-label"
                >Taki sam jak adres zamieszkania?</label
              >
              <select-field
                name="data[details][address2]"
                css="width: 100%"
                placeholder="Wybierz"
                :required="!is_expert"
                @changed="fillAddress($event, 'home', 'mailing')"
                :options="{
                  values: [
                    { val: 'Tak', text: 'Tak' },
                    { val: 'Nie', text: 'Nie' },
                  ],
                }"
                v-model="client.data.details.address2"
                :selected="client.data.details.address2"
              ></select-field>
            </div>
          </div>
        </div>
        <div v-if="client.data.details.address2 === 'Tak'">
          <input
            type="hidden"
            name="address[mailing][postal]"
            v-model="client.address.mailing.postal"
          />
          <input
            type="hidden"
            name="address[mailing][street]"
            v-model="client.address.mailing.street"
          />
          <input
            type="hidden"
            name="address[mailing][number]"
            v-model="client.address.mailing.number"
          />
          <input
            type="hidden"
            name="address[mailing][flat]"
            v-model="client.address.mailing.flat"
          />
          <input
            type="hidden"
            name="address[mailing][country]"
            v-model="client.address.mailing.country"
          />
          <input
            type="hidden"
            name="address[mailing][city]"
            v-model="client.address.mailing.city"
          />
          <input
            type="hidden"
            name="address[mailing][post_office]"
            v-model="client.address.mailing.post_office"
          />
          <input
            type="hidden"
            name="address[mailing][county]"
            v-model="client.address.mailing.county"
          />
          <input
            type="hidden"
            name="address[mailing][province]"
            v-model="client.address.mailing.province"
          />
        </div>
        <div v-else>
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="mailingPostal"
                  >Kod pocztowy</label
                >
                <input
                  type="text"
                  class="postal ang-form-control"
                  id="mailingPostal"
                  name="address[mailing][postal]"
                  :required="!is_expert && client.data.details.address2 === 'Nie'"
                  v-model="client.address.mailing.postal"
                  @keyup="getAddress($event.target.value, 'mailing')"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="mailingStreet">Ulica</label>
                <input
                  type="text"
                  class="ang-form-control"
                  id="mailingStreet"
                  name="address[mailing][street]"
                  :required="!is_expert && client.data.details.address2 === 'Nie'"
                  v-model="client.address.mailing.street"
                />
              </div>
            </div>
            <div class="col-6 col-md-2">
              <div class="form-group">
                <label class="ang-form-label" for="mailingNumber"
                  >Nr budynku</label
                >
                <input
                  type="text"
                  class="ang-form-control"
                  id="mailingNumber"
                  name="address[mailing][number]"
                  :required="!is_expert && client.data.details.address2 === 'Nie'"
                  v-model="client.address.mailing.number"
                />
              </div>
            </div>
            <div class="col-6 col-md-2">
              <div class="form-group">
                <label class="ang-form-label" for="mailingFlat"
                  >Nr lokalu</label
                >
                <input
                  type="text"
                  class="ang-form-control"
                  id="mailingFlat"
                  name="address[mailing][flat]"
                  v-model="client.address.mailing.flat"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="mailingCountry">Kraj</label>
                <input
                  type="text"
                  class="ang-form-control"
                  id="mailingCountry"
                  name="address[mailing][country]"
                  :required="!is_expert"
                  v-model="client.address.mailing.country"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="mailingCity">Miasto</label>
                <input
                  type="text"
                  class="ang-form-control"
                  id="mailingCity"
                  name="address[mailing][city]"
                  :required="!is_expert && client.data.details.address2 === 'Nie'"
                  v-model="client.address.mailing.city"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="mailingPostOffice"
                  >Poczta</label
                >
                <input
                  type="text"
                  class="ang-form-control"
                  id="mailingPostOffice"
                  name="address[mailing][post_office]"
                  :required="!is_expert && client.data.details.address2 === 'Nie'"
                  v-model="client.address.mailing.post_office"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="mailingCommune">Gmina</label>
                <input
                  type="text"
                  class="ang-form-control"
                  id="mailingCommune"
                  name="address[mailing][commune]"
                  :required="!is_expert && client.data.details.address2 === 'Nie'"
                  v-model="client.address.mailing.commune"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label" for="mailingCounty">Powiat</label>
                <input
                  type="text"
                  class="ang-form-control"
                  id="mailingCounty"
                  name="address[mailing][county]"
                  :required="!is_expert && client.data.details.address2 === 'Nie'"
                  v-model="client.address.mailing.county"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label">Województwo</label>
                <select-field
                  name="address[mailing][province]"
                  css="width: 100%"
                  :required="!is_expert && client.data.details.address2 === 'Nie'"
                  :options="dictionary.provinces"
                  @changed="refreshForm"
                  v-model="client.address.mailing.province"
                  :selected="client.address.mailing.province"
                ></select-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="alert alert-danger ang-alert-danger mt-3" v-if="error">
        <h5 class="ang-card-title">Wystąpił błąd!</h5>
        <label class="form-error error">{{ error }}</label>
      </div>
      <div class="d-flex align-items-end flex-column">
        <spinner v-if="sending"></spinner>
        <button
          v-else
          type="submit"
          class="btn btn-lg ang-button ang-btn-lg spinn"
        >
          Zapisz i przejdź dalej
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import ajax from "@/services/ajax";
import api from "@/services/api";
import dictionary from "@/services/dictionary";
import spinner from "@/components/partials/misc/spinner";
import select from "@/components/partials/misc/select";
import helper from "@/services/helper";
import $ from "jquery";
import moment from "moment";

export default {
  data() {
    return {
      success: false,
      error: null,
      sending: false,
      loading: true,
      client: null,
      showSecondID: false,
    };
  },
  props: ["base_client", "base", "code", "is_expert"],
  components: {
    spinner,
    "select-field": select,
  },
  mixins: [dictionary],
  watch: {
    "client.address.private": {
      deep: true,
      immediate: true,
      handler() {
        if (this.client?.data?.details?.address1 === "Tak") {
          this.client.address["home"] = JSON.parse(
            JSON.stringify(this.client.address["private"]),
          );
          $('select[name="address[home][province]"]').val(
            $('select[name="address[private][province]"]').val(),
          );
          $('select[name="address[home][province]"]').change();
        }
        if (this.client?.data?.details?.address2 === "Tak") {
          this.client.address["mailing"] = JSON.parse(
            JSON.stringify(this.client.address["home"]),
          );
          $('select[name="address[mailing][province]"]').val(
            $('select[name="address[home][province]"]').val(),
          );
          $('select[name="address[mailing][province]"]').change();
        }
        this.$forceUpdate();
      },
    },
    base_client() {
      console.log("test2");
      let self = this;
      this.client = this.base_client;

      this.client.data.details.issue_date = this.parseDate(
        this.client.data.details.issue_date,
      );
      this.client.data.details.validity_date = this.parseDate(
        this.client.data.details.validity_date,
      );
      this.client.data.details.issue_date_alt = this.parseDate(
        this.client.data.details.issue_date_alt,
      );
      this.client.data.details.validity_date_alt = this.parseDate(
        this.client.data.details.validity_date_alt,
      );
      this.client.data.details.birth_date = this.parseDate(
        this.client.data.details.birth_date,
      );
      this.$nextTick(function () {
        self.loading = false;
      });
    },
  },
  name: "personalForm",
  computed: {
    action() {
      return "/client/details/" + this.base;
    },
  },
  mounted() {
    let self = this;
    this.client = this.base_client;

    this.client.data.details.issue_date = this.parseDate(
      this.client.data.details.issue_date,
    );
    this.client.data.details.validity_date = this.parseDate(
      this.client.data.details.validity_date,
    );
    this.client.data.details.issue_date_alt = this.parseDate(
      this.client.data.details.issue_date_alt,
    );
    this.client.data.details.validity_date_alt = this.parseDate(
      this.client.data.details.validity_date_alt,
    );
    this.client.data.details.birth_date = this.parseDate(
      this.client.data.details.birth_date,
    );
    this.$nextTick(function () {
      self.loading = false;
      helper.maskPostal();
      ajax.postValidate(
        $(self.$refs.personalDataForm),
        self,
        function () {
          self.sending = false;
          self.$emit("forward", self.client);
        },
        function (data) {
          self.error = data.message;
          self.sending = false;
          $("html,body").animate({ scrollTop: $(document).height() }, "slow");
        },
        function () {
          self.error = null;
          self.sending = true;
        },
      );
      $(".datepicker")
        .datetimepicker({
          locale: "pl",
          format: "DD-MM-YYYY",
          useCurrent: false,
        })
        .on("change", function () {
          $(this).valid();
        })
        .unbind("change")
        .unbind("dp.change")
        .on("dp.change", function (e) {
          if ($(e.target).data("primary")) {
            if (
              typeof self.client.data.details.id_type === "undefined" ||
              !self.client.data.details.id_type ||
              ["Dowód osobisty", "Paszport"].indexOf(
                self.client.data.details.id_type,
              ) >= 0
            ) {
              //$(e.target).val() has a date in DD-MM-YYYY
              self.client.data.details.validity_date = moment(
                $(e.target).val(),
                "DD-MM-YYYY",
              )
                .add(10, "y")
                .format("DD-MM-YYYY");
            }
          }
          if ($(e.target).data("alt")) {
            if (
              typeof self.client.data.details.id_type_alt === "undefined" ||
              !self.client.data.details.id_type_alt ||
              ["Dowód osobisty", "Paszport"].indexOf(
                self.client.data.details.id_type_alt,
              ) >= 0
            ) {
              //$(e.target).val() has a date in DD-MM-YYYY
              self.client.data.details.validity_date_alt = moment(
                $(e.target).val(),
                "DD-MM-YYYY",
              )
                .add(10, "y")
                .format("DD-MM-YYYY");
              console.log(self.client.data.details.validity_date_alt);
            }
          }
          let event = document.createEvent("HTMLEvents");
          event.initEvent("input", true, true);
          e.currentTarget.dispatchEvent(event);
          $(this).trigger("change");
          $(this).valid();
          self.$forceUpdate();
        });
    });
  },
  methods: {
    parseDate(dateString) {
      if (
        dateString &&
        dateString.length > 4 &&
        moment(dateString, "YYYY-MM-DD", true).isValid()
      ) {
        return moment(dateString).format("DD-MM-YYYY");
      }
      return dateString;
    },
    getAddress(postal, addresType) {
      let self = this;
      let regex = new RegExp("^[0-9]{2}-[0-9]{3}$");
      if (regex.test(postal)) {
        api.get("/address/" + postal, {}, function (data) {
          if (data.length === 1) {
            self.client.address[addresType]["commune"] = data[0].gmina;
            self.client.address[addresType]["county"] = data[0].powiat;
            self.client.address[addresType]["city"] = data[0].miejscowosc;
            self.client.address[addresType]["country"] = "Polska";
            self.client.address[addresType]["post_office"] =
              data[0].miejscowosc;
            self.client.address[addresType]["street"] = data[0].ulica;
            $('select[name="address[' + addresType + '][province]"]').val(
              data[0].wojewodztwo,
            );
            $('select[name="address[' + addresType + '][province]"]').change();
            self.$forceUpdate();
          } else {
            let tmp_ar = data.filter(function (obj) {
              return obj.wojewodztwo !== data[0].wojewodztwo;
            });
            if (tmp_ar.length === 0) {
              $('select[name="address[' + addresType + '][province]"]').val(
                data[0].wojewodztwo,
              );
              $(
                'select[name="address[' + addresType + '][province]"]',
              ).change();
              tmp_ar = data.filter(function (obj) {
                return obj.powiat !== data[0].powiat;
              });
            } else {
              $('select[name="address[' + addresType + '][province]"]').val("");
              $(
                'select[name="address[' + addresType + '][province]"]',
              ).change();
            }

            if (tmp_ar.length === 0) {
              self.client.address[addresType]["county"] = data[0].powiat;
              tmp_ar = data.filter(function (obj) {
                return obj.gmina !== data[0].gmina;
              });
            } else {
              self.client.address[addresType]["county"] = "";
            }

            if (tmp_ar.length === 0) {
              self.client.address[addresType]["commune"] = data[0].gmina;
              tmp_ar = data.filter(function (obj) {
                return obj.miejscowosc !== data[0].miejscowosc;
              });
            } else {
              self.client.address[addresType]["commune"] = "";
            }

            if (tmp_ar.length === 0) {
              self.client.address[addresType]["city"] = data[0].miejscowosc;
              self.client.address[addresType]["post_office"] =
                data[0].miejscowosc;
              tmp_ar = data.filter(function (obj) {
                return obj.ulica !== data[0].ulica;
              });
            } else {
              self.client.address[addresType]["city"] = "";
              self.client.address[addresType]["post_office"] = "";
            }

            if (tmp_ar.length === 0) {
              self.client.address[addresType]["street"] = data[0].ulica;
            } else {
              self.client.address[addresType]["street"] = "";
            }

            self.$forceUpdate();
          }
        });
      }
    },
    fillAddress(object, paramFrom, paramTo) {
      if (object.value === "Tak") {
        this.client.address[paramTo] = JSON.parse(
          JSON.stringify(this.client.address[paramFrom]),
        );
        $('select[name="address[' + paramTo + '][province]"]').val(
          $('select[name="address[' + paramFrom + '][province]"]').val(),
        );
        $('select[name="address[' + paramTo + '][province]"]').change();
      }
      this.$forceUpdate();
    },
    onDocumentTypeChanged(object) {
      let self = this;
      this.$nextTick(
        () =>
          (self.showSecondID =
            self.client.data.details.id_type &&
            ["Paszport", "Karta pobytu"].indexOf(
              self.client.data.details.id_type,
            ) >= 0),
      );

      this.refreshForm();
      this.altDocumentCleanUp(object);
      this.$nextTick(() => $(self.$refs.personalDataForm).valid());
    },
    altDocumentCleanUp({ value }) {
      if (value === "Dowód osobisty") {
        this.client.data.details.id_type_alt = "";
        this.client.data.details.issue_date_alt = "";
        this.client.data.details.validity_date_alt = "";
        this.client.data.details.id_number_alt = "";
        this.client.data.details.id_issuer_alt = "";
      }
    },
    refreshForm() {
      this.$forceUpdate();
    },
    scrollToAnchor(aid) {
      let aTag = $("#" + aid);
      if (typeof aTag !== "undefined" && typeof aTag.offset() !== "undefined") {
        $("html,body").animate({ scrollTop: aTag.offset().top - 160 }, "slow");
      }
    },
  },
};
</script>
